/**
 * @desc 中文正则表达式
 */
export const REGEX_CHINESE = /[\u4e00-\u9fa5]/;

/**
 * @desc 日文正则表达式
 */
export const REGEX_JAPANESE =
    /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff00-\uff9f]|[\u4e00-\u9faf]|[\u3400-\u4dbf]/;

/**
 * @desc 韩文正则表达式
 */
export const REGEX_KOREAN = /[\uAC00-\uD7A3]/;

/**
 * @desc 获取一段string所占的字符长度
 * @param val 字符串
 * @param arabicCharLen 非汉字系字符长度，默认为1
 */
export function getCharLength(val: string, arabicCharLen = 1) {
    const hanziLen = arabicCharLen * 2;
    let len = 0;
    if (typeof val !== 'string') {
        return 0;
    }
    for (let i = 0; i < val.length; i++) {
        const str = val.charAt(i);
        if (checkStringContainChineseOrJapanese(str)) {
            len += hanziLen;
        } else {
            len += arabicCharLen;
        }
    }
    return len;
}

/**
 * @desc 获取特定字符长度的字符串；中文和日文占2个字符，其他的占1个字符
 * @param val
 * @param limit
 */
export function getLengthChar(val: string, limit: number) {
    let len = 0;
    let newChar = '';
    if (typeof val !== 'string') {
        return '';
    }
    for (let i = 0; i < val.length; i++) {
        const str = val.charAt(i);
        if (checkStringContainChineseOrJapanese(str)) {
            len += 2;
        } else {
            len += 1;
        }
        if (len <= limit) {
            newChar += str;
        } else {
            break;
        }
    }
    return newChar;
}

/**
 * @param str
 * @param maxCount 最大字符个数
 * @param maxLineCount 最大行数，0 不限制
 */
export const getCharCount = (str: string, maxCount = 0, maxLineCount = 0) => {
    if (!str) {
        return {
            length: 0,
            substring: str,
        };
    }

    if (maxLineCount > 0) {
        str = str.split('\n').slice(0, maxLineCount).join('\n');
    }

    let length = 0;
    let substring = '';
    for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i);
        if (checkStringContainChineseOrJapanese(char) || char === '\n') {
            length += 2;
        } else {
            length += 1;
        }
        if (maxCount >= length) {
            substring += char;
        }
    }
    return {
        length,
        substring,
    };
};

/**
 * 检查字符串是汉字系字符
 * @param stringVal 字符串
 * @returns boolean
 */
export function checkStringContainChineseOrJapanese(stringVal: string): boolean {
    return REGEX_JAPANESE.test(stringVal) || REGEX_CHINESE.test(stringVal) || REGEX_KOREAN.test(stringVal);
}
